import React, { Component } from 'react';

import { connect } from 'react-redux';

import { Route, Switch } from 'react-router-dom';

import { resetRegistration } from 'redux/ducks/Registration';
import { getEnums } from 'redux/ducks/Enum';

import Parent from './Parent';
import Patient from './Patient';
import PostEventAccount from './PostEventAccount';
import PostEventProfile from './PostEventProfile';
import PostEventShiftDetails from './PostEventShiftDetails';
import PostEventPassword from './PostEventPassword';
import PostEventContact from './PostEventContact';
import ContractConfirmation from './ContractConfirmation';
import ContractInfo from "./ContractInfo"
import Account from './Account';
import Profile from './Profile';
import Role from './Role';


import Layout from './Layout/Layout';
import RegistrationSteps from './RegistrationSteps';

export class RegistrationScene extends Component {
  componentWillMount() {
    this.props.getEnums();
  }

  componentWillUnmount() {
    this.props.resetRegistration();
  }

  render() {
    const { pathname } = this.props.location;
    const profile = pathname.includes("/post-event/profile");
    const HEADING = profile ?
      "Next, tell us a bit about yourself" :
      "Let's set up your free Go4 account"

    return (
      <Layout>
        <div className="registrationScene__left">
          <h1 className="registrationScene__heading">{HEADING}</h1>
          <RegistrationSteps />
        </div>
        <div className="registrationScene__right">
          <Switch>
            <Route path={`${this.props.match.url}/post-event/contact`} component={PostEventContact} />
            <Route path={`${this.props.match.url}/post-event/profile`} component={PostEventProfile} />
            <Route path={`${this.props.match.url}/post-event/shift-details`} component={PostEventShiftDetails} />
            <Route path={`${this.props.match.url}/post-event/password`} component={PostEventPassword} />
            <Route path={`${this.props.match.url}/account`} component={Account} />
            <Route path={`${this.props.match.url}/contract/organization`} component={PostEventProfile} />
            <Route path={`${this.props.match.url}/contract/details`} component={PostEventAccount} />
            <Route path={`${this.props.match.url}/contract/info`} component={ContractInfo} />
            <Route path={`${this.props.match.url}/contract/confirmation`} component={ContractConfirmation} />
            <Route path={`${this.props.match.url}/parent`} component={Parent} />
            <Route path={`${this.props.match.url}/patient`} component={Patient} />
            <Route path={`${this.props.match.url}/profile`} component={Profile} />
            <Route path={`${this.props.match.url}`} component={PostEventAccount} />
            {/* <Route path={`${this.props.match.url}/role`} component={Role} />
            <Route path={`${this.props.match.url}`} component={Role} /> */}
          </Switch>
        </div>
      </Layout>
    );
  }
}

function mapStateToProps(state) {
  return {
    role: state.registration.role,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resetRegistration: () => dispatch(resetRegistration()),
    getEnums: () => dispatch(getEnums()),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RegistrationScene);
